import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CircularProgressBar = ({ duration, className }) => {
    const animationDuration = `${duration / 2}ms`;

    return (
        <div className={classNames('circular-progress-bar', className)}>
            <div className="progress-left">
                <div className="circle-bar" style={{ animationDuration, animationDelay: animationDuration }} />
            </div>
            <div className="progress-right">
                <div className="circle-bar" style={{ animationDuration }} />
            </div>
        </div>
    );
};

CircularProgressBar.propTypes = {
    duration: PropTypes.number.isRequired,
    className: PropTypes.string,
};

export default CircularProgressBar;
